import { gql } from '@apollo/client';

// https://dev-dealer-graphql.apps.emea.vwapps.io/
// eslint-disable-next-line import/prefer-default-export
export const GET_DEALER = gql`
  query dealerById($dealerId: String!) {
    dealerById(dealerId: $dealerId) {
      services
    }
  }
`;
